<div class="important-message">
    <h2 class="title" [innerHTML]="message.title | safeHtml"></h2>
    <p class="content" [innerHTML]="message.content | safeHtml"></p>
</div>
